import { FC } from "react";
import "./Member.scoped.scss"

interface MemberProps {
  level: number;
  nickname: string;
  thumbnailUrl: string;
  todayComment?: string;
}

const Member: FC<MemberProps> = ({
  level,
  nickname,
  thumbnailUrl,
  todayComment,
}) => {
  return (
    <div className="member">
      <img
        className="member__thumbnail"
        src={thumbnailUrl}
        alt=""
      />
      <img 
        className="member__icon"
        src={`/img/level/level_img/${level}.png`}
        alt=""
      />
      <span>{nickname}</span>
      {
        (todayComment && todayComment !== '') 
          ? (
            <div className="member__message">
              <div>
                <span>{todayComment}</span>
              </div>
            </div>
          )
          : null
      }
    </div>
  )
}

export default Member;